import { writable } from "svelte/store";

class PropertyListItem {
	constructor(set) {
		this.property = "";
		this.value = "";
	}
}

class PropertyList {
	constructor(inputProps = {}) {
		this.properties = [];

		this.lastUpdated = writable(0);
		this.onChange = () => {
			this.lastUpdated.set(Date.now());
		};
		this._init(inputProps);
	}

	_init(inputProps) {
		const keys = Object.keys(inputProps);
		for (const i in keys) {
			const p = this.addProperty();
			p.property = keys[i];
			p.value = inputProps[keys[i]];
		}
		this.addOrRemovePropertyIfNecessary();
	}

	reset(data = {}) {
		for (let i = 0; i < this.properties.length; i++) {
			this.properties[i] = null;
		}
		this.properties = [];
		this._init(data);
		this.onChange();
	}

	addProperty() {
		const property = new PropertyListItem(this);
		this.properties = [...this.properties, property];
		this.onChange();
		return property;
	}

	removeProperty(property) {
		const ind = this.properties.indexOf(property);
		if (ind >= 0) {
			this.properties.splice(ind, 1);
		}
		this.onChange();
	}

	addOrRemovePropertyIfNecessary() {
		for (let i = this.properties.length - 1; i >= 0; i--) {
			if (this.properties[i].property === "" && i !== this.properties.length - 1) {
				this.removeProperty(this.properties[i]);
				i = this.properties.length;
			}
		}
		if (this.properties.length === 0 || this.properties[this.properties.length - 1].property !== "") {
			this.addProperty();
		}
		this.onChange();
	}

	get length() {
		return this.properties.length;
	}

	get data() {
		// TODO: do we want to convert things to ints and floats if they
		const obj = {};
		for (let i = 0; i < this.properties.length; i++) {
			const prop = this.properties[i];
			const key = prop.property;
			if (key.trim().length === 0) {
				continue;
			}
			if (!Number.isNaN(parseFloat(prop.value))) {
				obj[prop.property] = +prop.value;	 // convert to num
				if (Number.isNaN(obj[prop.property])) { // force to string if it's parsed as invalid.
					obj[prop.property] = "" + prop.value;
				}
			}
			else {
				obj[prop.property] = "" + prop.value;
			}
		}
		return obj;
	}

	get json() {
		return JSON.stringify(this.data);
	}
}
export default PropertyList;
